// Studio on the home screen: the VERA orb as the icon, named for who's signed in ("Marine Studio" for Marine, "VERA
// Studio" for everyone else). Phones read the name when the person adds Studio to their home screen, so the page points
// at the right manifest (Android, desktop Chrome) and sets the iPhone's own title (apple-mobile-web-app-title) first.
import { useEffect } from "react";

export const HOME_SCREEN = {
  studio: { manifest: "./studio.webmanifest", title: "VERA Studio" },
  marine: { manifest: "./marine-studio.webmanifest", title: "Marine Studio" },
} as const;

export type HomeScreenKind = keyof typeof HOME_SCREEN;

function setHead(rel: "manifest" | "title", value: string) {
  if (typeof document === "undefined") return;
  if (rel === "manifest") {
    let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) { link = document.createElement("link"); link.rel = "manifest"; document.head.appendChild(link); }
    if (link.getAttribute("href") !== value) link.setAttribute("href", value);
  } else {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "apple-mobile-web-app-title"; document.head.appendChild(meta); }
    meta.content = value;
  }
}

export function useHomeScreenName(kind: HomeScreenKind) {
  useEffect(() => {
    const { manifest, title } = HOME_SCREEN[kind];
    setHead("manifest", manifest);
    setHead("title", title);
  }, [kind]);
}

/** Running as the app on the home screen (not a browser tab): there, sign-in is remembered between visits. */
export function installedApp(): boolean {
  if (typeof window === "undefined") return false;
  const ios = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return ios || (typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches);
}
